import { Box, Button } from "@mui/material";
import React, { useRef, useState } from "react";
import { quizData } from "../../../../constants";
import { ResourceLinks } from "../../../../constants";

const WebHeader = ({ question }) => {
	const { questionData } = question;

    // for audio header
    const audioSrc = `${ResourceLinks.audio}instructions/${questionData?.id}.mp3`;
    const [playingAudioUrl, setPlayingAudioUrl] = useState("");
    const refs = useRef({});
    const skillImage = quizData.acsf4.icons.skills;


    const playAudio = (url) => {
        const previousUrl = playingAudioUrl;
        if (previousUrl !== "") {
            // we will set to empty to stop
            if (previousUrl !== url) {
                setPlayingAudioUrl("");
                refs.current[previousUrl].pause();

                // set play again
                setPlayingAudioUrl(url);
                refs.current[url].play();
            } else if (previousUrl === url) {
                // we will control the play or pause
                if (!refs.current[previousUrl].paused) {
                    setPlayingAudioUrl("");
                    refs.current[previousUrl].pause();
                } else {
                    setPlayingAudioUrl(previousUrl);
                    refs.current[previousUrl].play();
                }
            }
        } else {
            // play at initial
            setPlayingAudioUrl(url);
            refs.current[url].play();
        }
        
    }

    const handleEnded = () => {
        setPlayingAudioUrl("");
    }
    return (
        <Box
            sx={{
                display: "flex",
                boxSizing: "borde-box",
                borderBottom: "8px solid #016d7c", 
                backgroundColor: "white",
                flexGrow: "0",
                flexShrink: "0",
                userSelect: "none",
            }}
        >
            {/* For Icon */}
            <Box sx={{
                flexGrow: "0",
                flexShrink: "0",
                width: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <img src={skillImage[questionData?.skill ?? "learning"]} 
                    style={{
                        height: "60px",
                        width: "auto",
                        filter: "brightness(0) saturate(100%) invert(33%) sepia(7%) saturate(2668%) hue-rotate(143deg) brightness(99%) contrast(94%)",
                    }}
                    alt= "Img Icon"
                />
            </Box>
            <Box sx={{
                display: "flex",
                boxSizing: "border-box",
                minHeight: "80px",
                padding: "5px",
                flexGrow: "1",
                backgroundColor: "white",
                borderTop: "10px solid transparent",

            }}>
                <Box component="span"
                    sx={{ 
                        // marginTop: "8px",
                        whiteSpace: "pre-wrap",
                        display: "block",
                        flexGrow: "1",
                        fontSize: "1.5em",
                        fontWeight: "bold",
                        lineHeight: 1.2,
                    }}
                >
                    {questionData?.instructions
                        ? questionData?.instructions
                        : questionData?.questionText}
                </Box>
                {questionData && questionData?.skill === "oralcommunication" && 
                    (
                    <Button 
                        sx={{
                            position: "relative",
                            width: "60px",
                            padding: "0",
                            margin: "0 10px",
                            border: "none",
                            background: 'none',
                            outline: 'none',
                        }}
                        onClick={() => playAudio(audioSrc)}
                    >
                        <Box sx={{
                            position: "relative",
                        }}>
                            {playingAudioUrl === "" && (
                                <img src="data:image/png;base64,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"
                                    style={{
                                        height: "50px",
                                    }}
                                    alt= "Img Playing Play"
                                />
                            )}

                            <audio ref={(el) => refs.current[audioSrc] = el} src={audioSrc} onEnded={handleEnded}/>
                            {playingAudioUrl !== "" && (
                                <img src="data:image/png;base64,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" 
                                style={{
                                    position: "absolute",
                                    left: "-12px",
                                    top: "-16px",
                                    width: "28px",
                                    height: "32px",
                                }}
                                alt= "Img Playing Icon Stop"
                            />
                            )}
                        </Box>
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default WebHeader;
